export default __webpack_public_path__ + "static/media/RLC.57fe512d.webp";